define("checkout/components/input-stepper", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class={{concat-classes "o--btnGroup" (if @didAutoAdd "tCK--stepper tCK--stepper--hl")}}
    data-test-id="input-stepper"
  >
    <Shared::Ui::Button
      @isDisabled={{this.isStepDownDisabled}}
      @onClick={{@onStepDown}}
      @variant="outline"
      class="tCH--text--highlight qa--{{@id}}StepperDownBtn"
      data-test-id="input-stepper-down-button"
    >
      {{svg-jar "minus" class="o--icon--sm qa--minus_circle"}}
    </Shared::Ui::Button>
    {{#if (and this.isStepDownDisabled @tooltipAtMin)}}
      <EmberTooltip @delay={{330}} @side="top" data-test-id="input-stepper-down-tooltip">
        {{@tooltipAtMin}}
      </EmberTooltip>
    {{/if}}
    <Shared::Ui::Button
      @variant="outline"
      class="u--text--black qa--{{@id}}StepperValue"
      data-test-addon-id={{@testId}}
      data-test-id="input-stepper-value"
      data-test-value={{@currentValue}}
    >
      {{@currentValue}}
    </Shared::Ui::Button>
    <Shared::Ui::Button
      @isDisabled={{this.isSeamlessCheckoutInProgress}}
      @onClick={{@onStepUp}}
      @variant="outline"
      class="tCH--text--highlight qa--{{@id}}StepperUpBtn"
      data-test-id="input-stepper-up-button"
    >
      {{svg-jar "add" class="o--icon--sm qa--minus_circle"}}
    </Shared::Ui::Button>
  
  </div>
  */
  {
    "id": "wICHbbDg",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"o--btnGroup\",[52,[30,1],\"tCK--stepper tCK--stepper--hl\"]],null]],[14,\"data-test-id\",\"input-stepper\"],[12],[1,\"\\n  \"],[8,[39,2],[[16,0,[29,[\"tCH--text--highlight qa--\",[30,2],\"StepperDownBtn\"]]],[24,\"data-test-id\",\"input-stepper-down-button\"]],[[\"@isDisabled\",\"@onClick\",\"@variant\"],[[30,0,[\"isStepDownDisabled\"]],[30,3],\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,3],[\"minus\"],[[\"class\"],[\"o--icon--sm qa--minus_circle\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[41,[28,[37,4],[[30,0,[\"isStepDownDisabled\"]],[30,4]],null],[[[1,\"    \"],[8,[39,5],[[24,\"data-test-id\",\"input-stepper-down-tooltip\"]],[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[30,4]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[8,[39,2],[[16,0,[29,[\"u--text--black qa--\",[30,2],\"StepperValue\"]]],[16,\"data-test-addon-id\",[30,5]],[24,\"data-test-id\",\"input-stepper-value\"],[16,\"data-test-value\",[30,6]]],[[\"@variant\"],[\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[30,6]],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[8,[39,2],[[16,0,[29,[\"tCH--text--highlight qa--\",[30,2],\"StepperUpBtn\"]]],[24,\"data-test-id\",\"input-stepper-up-button\"]],[[\"@isDisabled\",\"@onClick\",\"@variant\"],[[30,0,[\"isSeamlessCheckoutInProgress\"]],[30,7],\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,3],[\"add\"],[[\"class\"],[\"o--icon--sm qa--minus_circle\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[13]],[\"@didAutoAdd\",\"@id\",\"@onStepDown\",\"@tooltipAtMin\",\"@testId\",\"@currentValue\",\"@onStepUp\"],false,[\"concat-classes\",\"if\",\"shared/ui/button\",\"svg-jar\",\"and\",\"ember-tooltip\"]]",
    "moduleName": "checkout/components/input-stepper.hbs",
    "isStrictMode": false
  });

  let InputStepperComponent = (_class = class InputStepperComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor, this);
    }

    get isStepDownDisabled() {
      return this.args.currentValue <= (this.args.minValue || 0) || this.isSeamlessCheckoutInProgress;
    }

    get isSeamlessCheckoutInProgress() {
      return this.seamlessCheckoutManager.isCheckoutInProgress;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = InputStepperComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, InputStepperComponent);
});